import React from 'react'
import { connect } from 'react-redux'

import { Show, SimpleShowLayout } from 'components/detail'
import { FunctionField } from 'components/field'

import * as urls from './urls'
import * as utils from './utils'

import { crudGetList as crudGetListAction } from 'actions/dataActions';


function getValueFromList(choices, value) {
  const choice = choices.find((choice) => (choice.id === value));
  if (choice) {
    return choice.name || '-';
  }

  return '-';
}

export const ReminderConfigDropDetailBase = (props) => {
  return (
    <Show 
      {...props}
      basePath={urls.reminderConfigFrontendPath}
      editPath="drop/"
      hasEdit={true}
      title="View Dropping Version"
    >
      <SimpleShowLayout>
        <FunctionField 
          label="App" 
          render={(record) => (
            getValueFromList(utils.APP_TYPE_LIST, record.app_type)
          )}
        />
        <FunctionField 
          label="Platform" 
          render={(record) => (
            getValueFromList(utils.CLIENT_TYPE_LIST, record.client_type)
          )}
        />
        <FunctionField 
          label="Version" 
          render={(record) => (
            record.dropping_version_number
          )}
        />
        <FunctionField 
          label="Last Support Date" 
          render={(record) => (
            utils.convertTimeToDate(record.dropping_version_last_support_day)
          )}
        />
      </SimpleShowLayout>
    </Show>
  )
};

export const ReminderConfigDropDetail = connect(
  () => ({}),
  {
    customFetch: () => (
      crudGetListAction(
        utils.ReminderConfigResourceName, 
        urls.reminderConfigBackendPath,
        {}
      )
    ),
  }
)(ReminderConfigDropDetailBase);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/ReminderConfigDropDetail.js